import React from "react";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";

import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  PageListBean,
  RestUserListRequest,
  UserSearchCriteria,
} from "../ds/ds.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { UserService } from "../services/UserService.js";
export class UserLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new UserSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let userLookupCriteria = new UserSearchCriteria();
    userLookupCriteria.companyCode = this.companyCode;
    let newCriteria = new UserSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = UserLookupCriteraHandler(
      companyCode,
      userLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(lookupDataCallback, userLookupCriteria, lookupCriteriaView);
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(
      this.attribute_name + " Name",
      "description",
      0,
      false
    ); //1
  }
  loadUserList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new UserSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.userCode = searchCriteria.userCode;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestUserListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    UserService.getUserPageList(
      requestInput,
      (response) => this.loadUserListResponse(response, lookup_dialog),
      this.loadUserListError
    );
  };
  loadUserListResponse = (response, lookup_dialog) => {
    let userList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.userPageList != null &&
      response.data.userPageList.users !== null
    ) {
      userList = response.data.userPageList.users;
      totalCount = response.data.userPageList.totalCount;
      currentPageNumber = response.data.userPageList.currentPage;
      pageSize = response.data.userPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = userList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadUserListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.code)) {
      if (!isEmptyString(filterText)) {
        search.userCode = filterText;
        this.searchCriteria = new UserSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadUserList(lookup_dialog, pageNumber, search);
    }
  }
}
const UserLookupCriteraHandler = (companyCode, userLookupCriteria) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new UserSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new UserSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>UserCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  ref={this.focusRef}
                  id="userCode"
                  name="userCode"
                  onChange={this.onChange}
                  value={searchCriteria.userCode}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                Continue[/]
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
